import { post } from '../../util'
import * as Sentry from '@sentry/browser';

export const GOOGLE_LOGIN_START = 'GOOGLE_LOGIN_START'
function loginStart() {
  return {
    type: GOOGLE_LOGIN_START,
  }
}

export const GOOGLE_LOGIN_ERROR = 'GOOGLE_LOGIN_ERROR'
function loginError(error, user) {
  return {
    type:  GOOGLE_LOGIN_ERROR,
    error: error.toState(),
    user,
  }
}

export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS'
function loginSuccess(response) {
  return {
    type: GOOGLE_LOGIN_SUCCESS,
    response,
  }
}

export const GOOGLE_SIGNUP_START = 'GOOGLE_SIGNUP_START'
function signupStart() {
  return {
    type: GOOGLE_SIGNUP_START,
  }
}

export const GOOGLE_SIGNUP_ERROR = 'GOOGLE_SIGNUP_ERROR'
function signupError(error, user) {
  return {
    type:  GOOGLE_SIGNUP_ERROR,
    error: error.toState(),
    user,
  }
}

export const GOOGLE_SIGNUP_SUCCESS = 'GOOGLE_SIGNUP_SUCCESS'
function signupSuccess(response) {
  return {
    type: GOOGLE_SIGNUP_SUCCESS,
    response,
  }
}

const getAuthParams = (user) => {
  return {
    ...user,
    source:      'google',
    source_page: document.location.pathname,
    feed_id:     user.username, // rename username to feedid for PHP
  }
}

export const doLogin = (user) => {
  return dispatch => {
    dispatch(loginStart())

    return post('/login_process.php', getAuthParams(user))
      .then(r => dispatch(loginSuccess(r)))
      .catch(error => {
        Sentry.addBreadcrumb({
          message: 'Google login error',
          data: {error, user},
          level: 'error',
          type: 'error',
        });
        dispatch(loginError(error, user))
      })
  }
}

export const doSignup = (user) => {
  return dispatch => {
    dispatch(signupStart(user))

    return post('/signup_process.php', getAuthParams(user))
      .then(r => dispatch(signupSuccess(r)))
      .catch(error => {
        Sentry.addBreadcrumb({
          message: 'Google signup error',
          data: {error, user},
          level: 'error',
          type: 'error',
        });

        dispatch(signupError(error, user))
      })
  }
}
